import { useState, useEffect } from 'react';

const DateTime = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setDate(new Date()), 1000);

    return () => clearInterval(interval);
  });

  const time = date.toLocaleTimeString('en-US', { hour12: false });
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  return (
    <p>
      {day}/{month}/{year}, {time}
    </p>
  );
};

export default DateTime;
